import React from 'react';

const ExternalLink = ({
  href,
  className,
  name,
  onClick,
}: {
  href: string;
  className?: string;
  name: string;
  onClick?: () => {};
}) => (
  <a href={href} className={className} rel="noopener noreferrer" target="_blank" onClick={onClick}>
    {name}
  </a>
);

export default ExternalLink;
